import { render, staticRenderFns } from "./center.vue?vue&type=template&id=013db51f&scoped=true"
import script from "./center.vue?vue&type=script&lang=js"
export * from "./center.vue?vue&type=script&lang=js"
import style0 from "./center.vue?vue&type=style&index=0&id=013db51f&prod&lang=scss&scoped=true"
import style1 from "./center.vue?vue&type=style&index=1&id=013db51f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013db51f",
  null
  
)

export default component.exports